/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_DeepgramInputs */

const en_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

const fr_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

const de_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

const it_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

const ru_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дипграм`)
};

const es_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

const zh_cn2_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迪普格拉姆`)
};

const ja_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディープグラム`)
};

const hi_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दीपग्राम`)
};

const pt_pt2_voice_manager_provider_deepgram = /** @type {(inputs: Voice_Manager_Provider_DeepgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deepgram`)
};

/**
* | output |
* | --- |
* | "Deepgram" |
*
* @param {Voice_Manager_Provider_DeepgramInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_deepgram = /** @type {((inputs?: Voice_Manager_Provider_DeepgramInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_DeepgramInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_deepgram(inputs)
	if (locale === "de") return de_voice_manager_provider_deepgram(inputs)
	if (locale === "it") return it_voice_manager_provider_deepgram(inputs)
	if (locale === "ru") return ru_voice_manager_provider_deepgram(inputs)
	if (locale === "es") return es_voice_manager_provider_deepgram(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_deepgram(inputs)
	if (locale === "ja") return ja_voice_manager_provider_deepgram(inputs)
	if (locale === "hi") return hi_voice_manager_provider_deepgram(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_deepgram(inputs)
	return en_voice_manager_provider_deepgram(inputs)
});